// extracted by mini-css-extract-plugin
export default {"containerBox":"styles_containerBox__541jq","hide":"styles_hide__VrmMc","show":"styles_show__hUE1G","profileImage":"styles_profileImage__YPZ5E"};